import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 14, onChange = null, testid = "star-rating" }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={testid}>
      {[1,2,3,4,5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(n)}
          className={onChange ? "cursor-pointer" : "cursor-default"}
          data-testid={`${testid}-${n}`}
        >
          <Star
            size={size}
            strokeWidth={1.25}
            className={n <= Math.round(value) ? "fill-secondary text-secondary" : "text-secondary/40"}
          />
        </button>
      ))}
    </div>
  );
}
